export default {
	history: {
		title: "Verlauf",
		description:
			"Jede Änderung im Designer wird als Commit festgehalten: was sich geändert hat, wer es geändert hat und wann.",
		refresh: "Aktualisieren",
		columns: {
			change: "Änderung",
			author: "Autor",
			when: "Zeitpunkt",
			commit: "Commit",
		},
		empty: "Bisher wurden keine Änderungen aufgezeichnet.",
		shown: "{count} Änderung angezeigt | {count} Änderungen angezeigt",
		older: "Ältere Änderungen anzeigen",
		loadFailed: "Der Verlauf konnte nicht geladen werden.",
	},
};
